import { Box, IconButton, Modal, Typography } from "@mui/material";
import WarningIcon from "../icon-components/WarningIcon";
import CloseIcon from "@mui/icons-material/Close";
import { t } from "i18next";

type AlertPopUpProps = {
  open: boolean;
  onClose: () => void;
  remainingMinutes: number;
};

const AlertPopUp: React.FC<AlertPopUpProps> = ({
  open,
  onClose,
  remainingMinutes,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: "10px",
          p: 2,
          outline: "none",
          zIndex: 5000,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "10rem"
          }}
        >
          <Typography
            id="modal-title"
            variant="body1"
            fontWeight={"700"}
            sx={{
              display: "flex",
              alignItems: "baseline",
              gap: "10px",
            }}
          >
            <WarningIcon
              height={"15px"}
              width={"15px"}
            />
            {t("alertPopup.alert")}
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Close"
            sx={{ p: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography
          id="modal-description"
          variant="body1"
          sx={{ mt: 2, mb: 3 }}
        >
          {t("alertPopup.alertMessage", {
            remainingMinutes:remainingMinutes
          })}
        </Typography>
      </Box>
    </Modal>
  );
};

export default AlertPopUp;
